import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { EMPTY, Subject } from 'rxjs';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import moment from 'moment';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ComboService } from '../../../Model/Combo/combo.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';


interface StateHoliday {
  Date: string
  ESS_CompanyHolidayMasterId: number
  ESS_HolidayMasterId: number
  HolidayName: string
  StateName: string
  TypesOfLeave: string
  Year: string
}

@Component({
  selector: 'app-state-holiday',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, ReactiveFormsModule, NgbNavModule, NgSelectModule, RouterModule],
  templateUrl: './state-holiday.component.html',
  styleUrl: './state-holiday.component.scss'
})

export class StateHolidayComponent {
  active = 1;
  StateHolidayData: StateHoliday[] = [];
  isDisabled: boolean = false;
  isDisabledTable: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective

  DisablesFilter = {
    Year: false,
    State: false,
  }

  HolidayMappingDetail = {
    StateId: 0,
    ESS_CompanyHolidayMaster: [],
  }

  filter = {
    SelectType: 1,
    StateId: null as any,
    Year: null as any,
    TypesOfLeave: null,
  }

  States = [] as any;
  StatesFilter = [] as any;
  Years = [] as any;
  TypesOfLeaves = ['NA', 'Compulsory', 'Optional'];
  dtoptions: DataTables.Settings = {};
  constructor(
    private holiday: HolidayService,
    private modalService: NgbModal,
    private toast: ToastService,
    private combo: ComboService,
    private utility: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.filter.StateId = parseInt(params['id']));
    this.route.params.subscribe(params => this.filter.Year = parseInt(params['year']));
    if (this.filter.StateId == 0) {
      this.filter.StateId = null;
      this.filter.Year = null;
    } else {
      this.DisablesFilter = {
        Year: true,
        State: true,
      }
    }
    this.SelectDate('RegistrationDate', null, null);
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('State');
    if (this.filter.StateId > 0) {
      this.GetStateHoliday();
    }
  }

  updateTypesOfLeave(value: string, element: any): void {
    element.TypesOfLeave = value;
  }
  
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': null, 'StateId': 0, 'DistrictId': 0, 'EmpMasterID': 0 }).subscribe({
      next: (response) => {
        if (Combotype == 'State') {
          this.States = response.ComboLoad;
          this.StatesFilter = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.filter.Year && this.filter.StateId) {
        this.GetStateHoliday();
      }
    }
    else {
      form.submitted = true;
    }
  }

  GetStateHoliday() {
    this.isDisabled = true;
    this.holiday.GetStateHoliday(this.filter).subscribe({
      next: (response) => {
        this.StateHolidayData = [];
        this.HolidayMappingDetail.ESS_CompanyHolidayMaster = response.Table;
        this.StateHolidayData = Object.values(response.Table)
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async SaveStateHoliday() {
    await this.common.getPageRights();
    if (this.HolidayMappingDetail.ESS_CompanyHolidayMaster.length > 0) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = this.HolidayMappingDetail.ESS_CompanyHolidayMaster.filter((e: any) => this.common.ToLowerCase(e.TypesOfLeave) == 'compulsory' || this.common.ToLowerCase(e.TypesOfLeave) == 'optional').length > 0 ? 'Do you want to save?' : 'All NA Holiday Type Will be Deleted. Do you want to delete?';
      modalRef.result.then((result: any) => {
        if ((this.filter.StateId == 0 && this.common.PageRight.IsAdd) || (this.filter.StateId > 0 && this.common.PageRight.IsEdit)) {
          if (result) {
            this.isDisabled = true;
            this.HolidayMappingDetail.StateId = this.filter.StateId;
            this.holiday.SaveStateHoliday(this.HolidayMappingDetail).subscribe({
              next: (response) => {
                if (response.Error_Code == '384') {
                  this.filter.StateId = null;
                  this.filter.Year = null;
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.close();
                    }
                  });

                  // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                  //   dtInstance.destroy();
                  //   this.dtTrigger.next(null);
                  // });
                }
                else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }).catch(() => {
        // Modal dismissed
      });
    } else {
      this.toast.show({ message: 'Please select holidays', type: toastTypeEnum.warning });
    }

  }

  ClearHolidays() {
    this.StateHolidayData = Object.values([]);
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  close(){
    this.router.navigate(['master/holiday/state']);
  }
}
